export const debitTypes = {
  '01': 'IRRF',
  '02': 'ISS',
  '03': 'INSS',
  '04': 'PIS',
  '05': 'COFINS',
  '06': 'CSLL',
  '07': 'Descontos financeiros',
  '08': 'Ajuste de demonstrativo anterior',
  '09': 'Bloqueio judicial',
};

export const DEBIT_INDICATOR = '1';

export function normalizeCode(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits ? digits.padStart(2, '0') : null;
}

export function getName(value) {
  return debitTypes[normalizeCode(value)] || null;
}

export function isTax(value) {
  return ['01', '02', '03', '04', '05', '06'].includes(normalizeCode(value));
}
